import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultVCycleElementDecoratorResource,
    useVCycleElementDecoratorActions,
    VCycleElementDecoratorMutationResourceSchema,
    type VCycleElementDecoratorResource,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementDecoratorResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../util/utilFunctions';
import { VCycleElementDecoratorContent } from './VCycleElementDecoratorContent';

export const VCycleElementDecoratorCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: VCycleElementDecoratorResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const vCycleElementDecoratorActions = useVCycleElementDecoratorActions();
    const addVCycleElementDecorator = vCycleElementDecoratorActions.useSetResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: VCycleElementDecoratorMutationResourceSchema,
        defaultValues: {
            ...defaultVCycleElementDecoratorResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addVCycleElementDecorator.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create V-Cycle Element Decorator'}
            resourceType={ResourceType.V_CYCLE_ELEMENT_DECORATOR}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <VCycleElementDecoratorContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
